import React, {Component} from "react";
import "./PasswordChange.css";
import {FormattedMessage} from "react-intl";
import FormFieldValidationError from '../../Common/FormFieldValidationError/FormFieldValidationError';
import axios from "axios";
import {BASE_URL, RESOURCE_BASE_URL} from "../../../configuration";
import Modal from "react-bootstrap/es/Modal";
import ModalFooter from "react-bootstrap/es/ModalFooter";
// import ".Register.css";
import "../Register/zocial.css";
import "../Register/patternfly-additions.css";
import "../Register/login.css";
import "../Register/Navigation.css";
import "../Register/styles.css";
import "../Register/bootstrap.css";
import "../Register/bootstrap-theme.css";
import "../../Common/Common.css";
import "../Register/Register.css";



class PasswordChange extends Component {

    constructor(props) {
        super(props);
        this.state = {
            oldPasswordError:"",
            oldPassword: "",
            password: "",
            verifyPassword: "",
            passwordError: "",
            newPasswordError: "",
            retypeNewPasswordError: "",
            userId: this.props.userId,
            username : "",
            passwordChangeMessage : "",
            passwordChangeStatus : false
        };
        this.onInputChange = this.onInputChange.bind(this);
        this.validatePassword = this.validatePassword.bind(this);
        this.validateNewPassword = this.validateNewPassword.bind(this);
        this.validateRetypeNewPassword = this.validateRetypeNewPassword.bind(this);
        this.handleClose = this.handleClose.bind(this);
        // this.getUerDetails = this.getUerDetails.bind(this);
    }

    handleClose = () => {
        let errMsg = document.getElementById("errormsg");
        errMsg.style.display = 'none';
        this.setState({
            show: false,
        },()=> {

        });
        localStorage.clear();
        window.location.replace(BASE_URL+'login');


    };

    validatePassword = () => {
        console.log("PASS ===> ", this.state.password);

        let oldPassword = this.state.oldPassword;

        if(oldPassword != ""){
            return true;
        }
        else{
            console.log("PASS ===> fail ");
            return false;
        }

    };

    validateNewPassword = () => {
        let password = this.state.password;

        console.log("NEW PASS ===> ", this.state.password);
        if (this.state.password !== this.state.oldPassword && this.state.verifyPassword !== "") {
            console.log("NEW PASS ===> pass");
            return true;
        }
        else{
            console.log("NEW PASS ===> fail");
            return false;

        }
    };

    validateRetypeNewPassword = () => {
        let verifyPassword = this.state.verifyPassword;
        console.log("RETYPE NEW PASS ===> ", this.state.verifyPassword);

        if (this.state.verifyPassword === this.state.password && this.state.verifyPassword !== "") {
            //this.setState({retypeNewPassword: event.target.value})
            console.log("RETYPE PASS ===> pass");
            return true;

        }
        else {
            console.log("RETYPE PASS ===> fail");
            return false;
        }

    };

    onInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            passwordError: "",
            newPasswordError: "",
            retypeNewPasswordError: ""
        });
    };

    componentDidMount() {
        this.setState({
            passwordError: "",
            newPasswordError: "",
            retypeNewPasswordError: ""
        });

        let errMsg = document.getElementById("errormsg");
        errMsg.style.display = 'none';

        // this.getUerDetails();
    }

    // getUerDetails = () => {
    //     let axiosConfig = {
    //         headers: {
    //             'Content-Type': 'application/json;charset=UTF-8',
    //             "Access-Control-Allow-Origin": "*",
    //         }
    //     };
    //
    //     axios.get(RESOURCE_BASE_URL + 'api/' +
    //         'users/' + this.props.userId , axiosConfig)
    //         .then((res) => {
    //             //alert("Password changed successfully");
    //             this.setState({
    //                 username: res.data.username,
    //             });
    //             console.log("user received ===>> ", res.data);
    //
    //             // this.props.keycloak.login({redirectUri : BASE_URL});
    //         })
    //         .catch((err) => {
    //             console.log("[API] ERROR: ", err);
    //         });
    // };

    changePassword = () => {

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.post(RESOURCE_BASE_URL + 'api/user-new/password/change'
            , {
                oldPassword: this.state.oldPassword,
                password: this.state.password,
                verifyPassword: this.state.verifyPassword,
            }, axiosConfig)
            .then((res) => {
                let message = "";
                let status = false;
                if(res.data.statusCode === "S0000000"){
                    message = "パスワードは正常に変更されました。";
                    status = true;
                }else {
                    message = "パスワードの変更に失敗しました。";
                    status = false;
                }

                this.setState({
                    show: true,
                    passwordChangeMessage : message,
                    passwordChangeStatus : status
                });

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                let responseBody = JSON.parse(JSON.stringify(err));
                if (responseBody.response.data.message === "Current password provided is wrong") {
                    this.setState({oldPasswordError: "古いパスワードが一致しません"});
                    let errMsg = document.getElementById("errormsg");
                    errMsg.style.display = 'block';
                }

            });
        this.setState({
            oldPasswordError: '',
        });
    };

    onSubmit = (event) => {
        let passwordError = "";
        let newPasswordError = "";
        let retypeNewPasswordError = "";
        let validationPassed = true;

        if (this.validatePassword(event) === false) {
            validationPassed = false;
            passwordError = "app.validation.change-password.empty-password";
           // passwordError = "Enter the password";
        }
        if (this.validateNewPassword(event) === false) {
            validationPassed = false;
            newPasswordError = "app.validation.change-password.empty-password";
            //retypeNewPasswordError = "Enter a new password";
        }

        if (this.validateRetypeNewPassword(event) === false) {
            validationPassed = false;
            retypeNewPasswordError = "app.validation.change-password.empty-password";
            //retypeNewPasswordError = "Enter the same new password";
        }

        console.log("VALIDATION ===> ", validationPassed);

        if (validationPassed) {
            console.log("Validation passed");
            // Proceed
            // this.setState({
            //     show: true,
            // });
            this.changePassword();

            // this.props.history.push("/logout");
        } else {
            event.preventDefault();
            this.setState({passwordError, newPasswordError, retypeNewPasswordError});
        }
    };


    render() {
        return (
            <div className="change-password-div">
                    <div className="change-password-title">
                        <FormattedMessage id="app.changeNewPassword.title"
                                          defaultMessage="CHANGE YOUR PASSWORD"
                                          description=""/>
                    </div>
                    <hr />
                    <div className="container-fluid">
                        {/*<div className="row">*/}
                            {/*<div className="col-md-6">*/}
                                {/*<label>*/}
                                    {/*<FormattedMessage id="app.changeNewPassword.current"*/}
                                                      {/*defaultMessage="Current Password"*/}
                                                      {/*description=""/>*/}
                                {/*</label>*/}
                            {/*</div>*/}
                            {/*<div className="col-md-6 no-padding">*/}
                                {/*<input type="password"*/}
                                       {/*className="password-input"*/}
                                       {/*name="password"*/}
                                       {/*value={this.state.password}*/}
                                       {/*onChange={this.onInputChange}*/}
                                {/*/>*/}
                            {/*</div>*/}
                            {/*<FormFieldValidationError errors={this.state.passwordError}/>*/}
                        {/*</div>*/}

                        <div id="errormsg" className="alert alert-error">
                            <span className="kc-feedback-text">{this.state.oldPasswordError}</span>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label>
                                    <FormattedMessage id="app.changeNewPassword.oldPassword"
                                                      defaultMessage="Re-type New Password"
                                                      description=""/>
                                </label>
                            </div>
                            <div className="col-md-6 no-padding">
                                <input type="password"
                                       name="oldPassword"
                                       value={this.state.oldPassword}
                                       onChange={this.onInputChange}
                                       // className="password-input"
                                />
                            </div>
                            <FormFieldValidationError errors={this.state.passwordError}/>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label>
                                    <FormattedMessage id="app.changeNewPassword.new"
                                                      defaultMessage="New Password"
                                                      description=""/>
                                </label>
                            </div>
                            <div className="col-md-6 no-padding">
                                <input type="password"
                                       name="password"
                                       // className="password-input"
                                       value={this.state.password}
                                       onChange={this.onInputChange}
                                />
                            </div>
                            <FormFieldValidationError errors={this.state.newPasswordError}/>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label>
                                    <FormattedMessage id="app.changeNewPassword.retype"
                                                      defaultMessage="Old Password"
                                                      description=""/>
                                </label>
                            </div>
                            <div className="col-md-6 no-padding">
                                <input type="password"
                                       name="verifyPassword"
                                    // className="password-input"
                                       value={this.state.verifyPassword}
                                       onChange={this.onInputChange}
                                />
                            </div>
                            <FormFieldValidationError errors={this.state.retypeNewPasswordError}/>
                        </div>
                        <div className="row">
                            <div className="col-md-6">&nbsp;</div>
                            <div className="col-md-6 no-padding">

                                <button onClick={this.onSubmit} className="btn btn-warning change-password-btn-outline"  disabled={ (this.state.oldPassword === this.state.password  || this.state.password !== this.state.verifyPassword)} >
                                    <FormattedMessage id="app.changeNewPassword.update"
                                                      defaultMessage="Update"
                                                      description=""/>
                                </button>
                            </div>
                        </div>

                        <Modal dialogClassName="password-modal" show={this.state.show} onHide={this.handleClose}>
                            <Modal.Header closeButton>
                                <b><FormattedMessage id="app.changeNewPassword.title"
                                                  defaultMessage="CHANGE YOUR PASSWORD"
                                                  description=""/></b>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="color-text">
                                    <div className="password-change-modal-text">
                                        {this.state.passwordChangeMessage}
                                    </div>

                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <button className="btn btn-primary pull-right" onClick={this.handleClose}>
                                    閉じる

                                </button>
                            </Modal.Footer>
                        </Modal>

                    </div>
            </div>
        );
    }
}
export default PasswordChange;



// WEBPACK FOOTER //
// ./src/components/Site/PasswordChange/PasswordChange.js